import gql from 'graphql-tag'

export default gql`
  fragment FieldStatsData on FieldStatsNode {
      minValue
      maxValue
      meanValue
  }
`